<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }} - 3D Viewer</h4>
    <button
      type="button"
      class="btn btn-primary pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-view3d [model3dId]="model3dId" [id]="id"></app-view3d>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">
      Close
    </button>
  </div>
</div>
